class RetailMedia {
    constructor() {
        this.queue = [];
    }

    init() {
        if (!Array.isArray(window.retailMediaBlocksQueue)) {
            window.retailMediaBlocksQueue = [];
        }

        this.queue = this.queue.concat(window.retailMediaBlocksQueue);
        window.retailMediaBlocksQueue = [];

        this.queue.forEach((config) => this.create(config));
        this.queue = [];
    }

    create(config) {
        if (!config || !config.containerId || !config.pageId || !config.impId) {
            return;
        }

        const container = document.getElementById(config.containerId);
        if (!container) {
            return;
        }

        const replaceNode = config.replaceSelector
            ? document.querySelector(config.replaceSelector)
            : null;

        const containerHasCreative = () =>
            container.childElementCount > 0 ||
            container.textContent.trim() !== '';

        const hideReplaceNode = () => {
            if (replaceNode) {
                replaceNode.style.display = 'none';
            }
        };

        const showReplaceNode = () => {
            if (replaceNode) {
                replaceNode.style.display = '';
            }
        };

        if (replaceNode) {
            const observer = new MutationObserver(() => {
                if (containerHasCreative()) {
                    hideReplaceNode();
                    observer.disconnect();
                }
            });

            observer.observe(container, {
                childList: true,
                subtree: true,
                attributes: true,
            });
        }

        const notifyServed = () => {
            if (typeof config.onServed === 'function') {
                config.onServed();
            }
        };

        // MutationObserver для отслеживания появления креатива (onServed callback).
        if (typeof config.onServed === 'function') {
            let notified = false;
            const servedObserver = new MutationObserver(() => {
                if (!notified && containerHasCreative()) {
                    notified = true;
                    notifyServed();
                    servedObserver.disconnect();
                }
            });
            servedObserver.observe(container, {
                childList: true,
                subtree: true,
            });
        }

        const callCreate = () => {
            window.Ya.RetailMedia.create({
                pageId: config.pageId,
                containerId: config.containerId,
                impId: config.impId,
                callbacks: {
                    altCallback: () => {
                        container.style.display = 'none';
                        showReplaceNode();
                    },
                },
            });

            if (containerHasCreative()) {
                hideReplaceNode();
            }
        };

        // Если SDK уже загружен — вызываем напрямую.
        // Иначе — кладём в очередь yaRetailMediaCb, которую SDK выполнит при загрузке.
        if (window.Ya?.RetailMedia) {
            callCreate();
        } else {
            window.yaRetailMediaCb = window.yaRetailMediaCb || [];
            window.yaRetailMediaCb.push(callCreate);
        }
    }
}

const retailMedia = new RetailMedia();

export { RetailMedia, retailMedia };
